import React, { useState } from "react";
import {
  Tooltip,
  IconButton,
  Button,
  Popper,
  Paper,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import {
  OpenInNewWindowIcon,
  CallMadeIcon,
  SMSOutgoingIcon,
  CustomerIcon,
  ElevationIcon,
} from "../../../../components/mui/index.js";
import { useSingleInvoiceActions } from "../actions/single-action.component.js";

export function OverageSinglePopper({ data, snackbarRef, onActionComplete }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const single = useSingleInvoiceActions({
    snackbarRef,
  });

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  // Helper for making the whole action area clickable
  const handleSmsOverageClick = (e) => {
    e.stopPropagation();
    if (!data.accountId) {
      snackbarRef.current?.addSnackbar({
        type: "error",
        message: `Please link an account to QuickBooks Invoice ${data.invoice?.Id} before updating SMS overage`,
      });
      return;
    }
    single.openSmsOverageModal(data, (result) => {
      onActionComplete && onActionComplete(result);
    });
    handleClose();
  };

  const handleCustomerCountOverageClick = (e) => {
    e.stopPropagation();
    if (!data.accountId) {
      snackbarRef.current?.addSnackbar({
        type: "error",
        message: `Please link an account to QuickBooks Invoice ${data.invoice?.Id} before updating Customer Count overage`,
      });
      return;
    }
    single.openCustomerCountOverageModal(data, (result) => {
      onActionComplete && onActionComplete(result);
    });
    handleClose();
  };

  return (
    <>
      <Tooltip title={!open ? <Typography>Overage Actions</Typography> : null}>
        <IconButton onClick={handleClick}>
          <ElevationIcon />
        </IconButton>
      </Tooltip>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper sx={{ p: 2, minWidth: 260 }}>
            <Stack
              spacing={2}
              direction="row"
              alignItems="center"
              justifyContent="center"
              sx={{ width: "100%" }}
            >
              {/* SMS Overage Action */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 1,
                  cursor: "pointer",
                  borderRadius: 2,
                  transition: "background 0.2s",
                  "&:hover": {
                    backgroundColor: "#f0f7ff",
                  },
                  py: 1,
                }}
                onClick={handleSmsOverageClick}
                tabIndex={0}
                role="button"
                aria-label="Add SMS Overage"
              >
                <Tooltip
                  title={
                    !!data.accountId ? (
                      <Typography>
                        Add Sms Overage to this month's invoice
                      </Typography>
                    ) : (
                      <Typography>
                        Please link an account to this invoice before updating
                        SMS overage
                      </Typography>
                    )
                  }
                  placement="top"
                  arrow
                >
                  <span>
                    <SMSOutgoingIcon
                      color="primary"
                      fontSize="large"
                      sx={{ mb: 0.5 }}
                    />
                  </span>
                </Tooltip>
                <Typography
                  variant="caption"
                  sx={{ mt: 0.5, fontWeight: 500, textAlign: "center" }}
                >
                  SMS Overage
                </Typography>
              </Box>

              {/* Customer Count Overage Action */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 1,
                  cursor: "pointer",
                  borderRadius: 2,
                  transition: "background 0.2s",
                  "&:hover": {
                    backgroundColor: "#f0f7ff",
                  },
                  py: 1,
                }}
                onClick={handleCustomerCountOverageClick}
                tabIndex={0}
                role="button"
                aria-label="Add Customer Count Overage"
              >
                <Tooltip
                  title={
                    !!data.accountId ? (
                      <Typography>
                        Add Customer Count Overage to this month's invoice
                      </Typography>
                    ) : (
                      <Typography>
                        Please link an account to this invoice before updating
                        Customer Count overage
                      </Typography>
                    )
                  }
                  placement="top"
                  arrow
                >
                  <span>
                    <CustomerIcon
                      color="primary"
                      fontSize="large"
                      sx={{ mb: 0.5 }}
                    />
                  </span>
                </Tooltip>
                <Typography
                  variant="caption"
                  sx={{ mt: 0.5, fontWeight: 500, textAlign: "center" }}
                >
                  Customer Count Overage
                </Typography>
              </Box>
            </Stack>
          </Paper>
        </ClickAwayListener>
      </Popper>
      {single.modals}
    </>
  );
}
